var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgFileFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.75C0 1.67893 1.71798 0 3.83721 0H18.1628C20.282 0 22 1.67893 22 3.75V18.7901C22 20.0106 20.9876 21 19.7387 21C19.1989 21 18.6769 20.8113 18.267 20.468L15.7397 18.3509C15.6474 18.2736 15.5121 18.2705 15.4162 18.3434L12.7276 20.387C11.7115 21.1594 10.2885 21.1594 9.2724 20.387L6.58383 18.3434C6.48786 18.2705 6.35261 18.2736 6.2603 18.3509L3.73298 20.468C3.32313 20.8113 2.80113 21 2.26133 21C1.01243 21 0 20.0106 0 18.7901V3.75ZM4.60465 4.75C4.60465 4.33579 4.94825 4 5.37209 4H16.6279C17.0518 4 17.3953 4.33579 17.3953 4.75C17.3953 5.16421 17.0518 5.5 16.6279 5.5H5.37209C4.94825 5.5 4.60465 5.16421 4.60465 4.75ZM4.60465 8.75C4.60465 8.33579 4.94825 8 5.37209 8H7.4186C7.84245 8 8.18605 8.33579 8.18605 8.75C8.18605 9.16421 7.84245 9.5 7.4186 9.5H5.37209C4.94825 9.5 4.60465 9.16421 4.60465 8.75ZM10.4884 8C10.0645 8 9.72093 8.33579 9.72093 8.75C9.72093 9.16421 10.0645 9.5 10.4884 9.5H16.6279C17.0518 9.5 17.3953 9.16421 17.3953 8.75C17.3953 8.33579 17.0518 8 16.6279 8H10.4884ZM4.60465 12.75C4.60465 12.3358 4.94825 12 5.37209 12H16.6279C17.0518 12 17.3953 12.3358 17.3953 12.75C17.3953 13.1642 17.0518 13.5 16.6279 13.5H5.37209C4.94825 13.5 4.60465 13.1642 4.60465 12.75Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFilled);
export default __webpack_public_path__ + "static/media/fileFilled.dc3ed266388d3dc333a9c114667504d4.svg";
export { ForwardRef as ReactComponent };